<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <a-spin :spinning="spinning">
            <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                    <base-input alternative="" label="As of"><br>
                                        <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortExtendedBy" @click.prevent="autoChange">
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                            </div>
                        </div>
                    </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" v-on:click='clearJsonData'> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                                </download-excel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
                <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                    <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
                </a-drawer>
            </div>
            </a-spin>
        </div>
    </a-spin>
</template>
    
<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'

    import {
        mapState,
        mapActions
    } from 'vuex'
    import { getReportDescription } from '../../utilities';
    var component_x;

    export default {
        data() {
            return {
                spinning: false,
                inputDate: moment().endOf('day'),
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'division_id', value: 'Division'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputSortBy: 'stock_no',
                inputSortExtendedBy: 'stock_no',
                sortOptions: [
                    {key: 'stock_no', value: 'MFG Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'},
                    {key: 'onhand_qty', value: 'On-Hand Quantity'},
                ],
                birSalesReports: [],

                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                toggleAdvanceFilter: false,
                toggleLabel: "Advanced Filter",
                advancedFilterParams: {},
                params: {},
                advancedFilterVisible: true,
                spinning: false,
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: ''
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile','endPoint']),
        },
        components:{
            AdvanceFilter,VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == 'product_id' || e.target.value == 'barcode' || e.target.value == 'name' || e.target.value == 'onhand_qty'){
                    this.inputSortBy = this.inputSortExtendedBy
                } else {
                    this.inputSortBy = 'product_id'
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            advanceFilter(value){
                this.toggleAdvanceFilter = value
                if(this.toggleAdvanceFilter == true){
                    this.toggleLabel = "Collapse Filter"
                }else{
                    this.toggleLabel = "Advanced Filter"
                }
            },
            closeFilter(){
                this.advanceFilter(false)
            },
            changeParams(params, actualParams, mode){
                this.advancedFilterParams = actualParams

                if(mode == 'filter'){
                    this.advanceFilter(false);
                }
            },
            convertToCurrency(num, scale){
                return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            diffDays(date1, date2){
                let a = moment(date1,'YYYY-MM-DD');
                let b = moment(date2,'YYYY-MM-DD');
                return b.diff(a, 'days');
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }
                let sorting = this.inputSortBy
                let as_of = this.inputDate.format('MMMM DD, YYYY')

                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_cost_layer?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }

                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let doc = []
                    doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a3' });
                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                    let group_text = ""
                    let headers = [];

                    let header_top = [];
                    header_top.push(
                        {content: 'Stock #', styles: {halign: 'center'}},
                        {content: 'Barcode', styles: {halign: 'center'}},
                        {content: 'Description', styles: {halign: 'center'}},
                        {content: 'Quantity', styles: {halign: 'center'}},
                        {content: 'Cost', styles: {halign: 'center'}},
                        {content: 'Reference Document', styles: {halign: 'center'}},
                        {content: 'Post Date', styles: {halign: 'center'}},
                        {content: 'Ref Line No', styles: {halign: 'center'}}
                    )
                    headers = [header_top]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.ReportDetails = siteSpecific[x].report_details

                        if(x > 0 && this.ReportDetails.length > 0){
                            doc.addPage();
                        }
                        let grand_qty = 0
                        let reportData = [];
                        if(this.ReportDetails.length > 0){
                            let grouper = 'start'

                            let total_qty = 0
                            let total_qty_per_item = 0
                            let status = false

                            for(let i=0; i < this.ReportDetails.length; i++){
                                let reportLine = this.ReportDetails[i]
                                let grouper_name = reportLine.grouper_name

                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_name){
                                        let detail_header = [{content: grouper_name, colSpan: 5, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_name
                                let detail = [
                                    reportLine.stock_no,
                                    reportLine.barcode,
                                    {content: reportLine.name, styles: {halign: 'left'}},
                                    Number(reportLine.quantity),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost), 6), 'Z'),
                                    reportLine.doc_type,
                                    moment(reportLine.date).format('MM/DD/YYYY hh:mm a'),
                                    reportLine.reference_line_no,
                                ]
                                try {
                                    if(this.ReportDetails[i-1].barcode == reportLine.barcode){
                                        total_qty_per_item += Number(reportLine.quantity)
                                        status = true
                                    } else if(this.ReportDetails[i-1].barcode != reportLine.barcode && status){
                                        status = false
                                        let sub_detail_per_item = ['', '']
                                        sub_detail_per_item.push(
                                            'Total per Item :',
                                            this.convertToCurrency(total_qty_per_item, 2)
                                        )
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail_per_item))
                                        total_qty_per_item = Number(reportLine.quantity)
                                    }else {
                                        total_qty_per_item = Number(reportLine.quantity)
                                    }
                                } catch (error) {
                                    total_qty_per_item = Number(reportLine.quantity)
                                }
                                reportData.push(Object.assign({}, detail))
                                total_qty += Number(reportLine.quantity)
                                grand_qty += Number(reportLine.quantity)

                                if(i == this.ReportDetails.length-1){
                                    let sub_detail = ['', '']
                                    let grand_detail = ['', '']
                                    sub_detail.push(
                                        'SubTotal :',
                                        this.convertToCurrency(total_qty, 2)
                                    )
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.convertToCurrency(grand_qty, 2)
                                    )
                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, sub_detail))

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, grand_detail))
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.ReportDetails[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '']
                                        sub_detail.push(
                                            'SubTotal :',
                                            this.convertToCurrency(total_qty, 2)
                                        )
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))

                                        total_qty = 0
                                    }
                                }
                            }
                        }

                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }
                        let design_x = 340
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Inventory Cost Layer Report" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        if(this.isSeparateSite == true){
                            doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(design_x+60,20,site_text,"right");
                        }
                        doc.text(15,25,"As of " + as_of)

                        let colStyles = {}
                        colStyles = {
                            0: {cellWidth: 45},
                            1: {cellWidth: 45},
                            2: {cellWidth: 90},
                            3: {cellWidth: 35},
                            4: {cellWidth: 35},
                            5: {cellWidth: 60},
                            6: {cellWidth: 45},
                            7: {cellWidth: 35},
                        }
                        doc.autoTable({
                            startY: 35,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            margin: {bottom: 25},
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[2] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :' || data.row.raw[2] == 'SubTotal :' || data.row.raw[3] == 'Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                    }
                    let pageCount = doc.internal.getNumberOfPages();
                    let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "Inventory Cost Layer Report" + group_text, 400, 280, i, pageCount)
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    return
                }
                let sorting = this.inputSortBy
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                    "group": this.inputGroupBy,
                    "order": sorting,
                    "by": this.showSortInfo,
                    "isSeparate": this.isSeparateSite,
                }
                let get_request = await HTTPRequest.getRequest(this.endPoint + 'inventory_cost_layer?', parameters);

                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return
                }
                let siteSpecific = get_request;
                if(siteSpecific.length > 0){
                    let headers = [];
                    let header_top = [];
                    let site_specific = [];
                    header_top.push('Stock #','Barcode','Description','Quantity','Cost','Reference Document','Post Date','Ref Line No')
                    headers = header_top
                    for (let x=0; x < siteSpecific.length; x++){
                        this.ReportDetails = siteSpecific[x].report_details
                        let grand_qty = 0
                        let reportData = [];
                        if(this.ReportDetails.length > 0){
                            let grouper = 'start'

                            for(let i=0; i < this.ReportDetails.length; i++){
                                let total_qty = 0
                                let reportLine = this.ReportDetails[i]
                                let grouper_name = reportLine.grouper_name
                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(detail_header)
                                } else {
                                    if(grouper != reportLine.grouper_name){
                                        let detail_header = [grouper_name]
                                        reportData.push(detail_header)
                                    }
                                }
                                grouper = reportLine.grouper_name
                                let detail = [
                                    reportLine.stock_no,
                                    reportLine.barcode,
                                    reportLine.name,
                                    Number(reportLine.quantity),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost), 6), 'Z'),
                                    reportLine.doc_type,
                                    moment(reportLine.date).format('MM/DD/YYYY hh:mm a'),
                                    reportLine.reference_line_no,
                                ]
                                reportData.push(detail)

                                total_qty += Number(reportLine.quantity)
                                grand_qty += Number(reportLine.quantity)

                                if(i == this.ReportDetails.length-1){
                                    let sub_detail = ['', '']
                                    let grand_detail = ['', '']
                                    sub_detail.push(
                                        'Sub Total :',
                                        this.convertToCurrency(total_qty, 2)
                                    )
                                    grand_detail.push(
                                        'Grand Total :',
                                        this.convertToCurrency(grand_qty, 2)
                                    )
                                    reportData.push(["---"])
                                    reportData.push(sub_detail)

                                    reportData.push(["---"])
                                    reportData.push(grand_detail)
                                } else {
                                    let current_grouper = reportLine.grouper_id
                                    let next_grouper = this.ReportDetails[i+1].grouper_id

                                    if(current_grouper != next_grouper){
                                        let sub_detail = ['', '']
                                        sub_detail.push(
                                            'Sub Total :',
                                            this.convertToCurrency(total_qty, 2)
                                        )
                                        reportData.push(["-----"])
                                        reportData.push(sub_detail)

                                        total_qty = 0
                                    }
                                }
                            }
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                        }

                        if(this.isSeparateSite == true){
                            reportData.push([siteSpecific[x].report_details[0].site_name]);
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            reportData.unshift([site_text]);
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Printed By: " + printed_by, "","","","","","","Inventory Cost Layer Report" + group_text])
                        reportData.push(["Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                            )
                            );
                            newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                            }
                            }
                        });
                        site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
                                        }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
                this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>